import React from "react";
import Input from "../../components/Input/Input";
import Select from "../../components/Select/Select";
import MultiSelect from "../../components/Select/MultiSelect";
import Button from "../../components/Button/Button";

const QueryFilter = ({
  headerArray,
  id_number,
  organizationList,
  organization_id,
  stakeholder_email,
  ticket_no,
  stakeholder_mob,
  request_type,
  reply_status,
  requestTypeList,
  searchHandler,
  onChangeHandler,
  resetHandler,
  excelDownloadHandler,
  excelHeaderHandler,
  selectedHeaders,
  start_date,
  end_date,
  isDownloadLoader,
}) => {
  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col-md-4">
          <Input
            type="text"
            name="id_number"
            id="id_number"
            value={id_number}
            placeholder={"Admission No"}
            onChangeHandler={(e) => onChangeHandler(e)}
          />
        </div>
        <div className="col-md-4">
          <Select
            name="organization_id"
            id="organization_id"
            value={organization_id}
            placeholder={"Select School"}
            onChangeHandler={(e) => onChangeHandler(e)}
            options={organizationList && organizationList}
          />
        </div>
        <div className="col-md-4">
          <Input
            type="text"
            name="stakeholder_email"
            id="stakeholder_email"
            placeholder={"Email"}
            value={stakeholder_email}
            onChangeHandler={(e) => onChangeHandler(e)}
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-md-4">
          <Input
            type="text"
            name="ticket_no"
            id="ticket_no"
            placeholder={"Query No"}
            value={ticket_no}
            onChangeHandler={(e) => onChangeHandler(e)}
          />
        </div>
        <div className="col-md-4">
          <Input
            type="number"
            name="stakeholder_mob"
            id="stakeholder_mob"
            placeholder={"Mobile No"}
            value={stakeholder_mob}
            onChangeHandler={(e) => onChangeHandler(e)}
          />
        </div>
        <div className="col-md-2">
          <Input
            type="date"
            name="start_date"
            id="start_date"
            placeholder={"Start Date"}
            value={start_date}
            onChangeHandler={(e) => onChangeHandler(e)}
          />
        </div>
        <div className="col-md-2">
          <Input
            type="date"
            name="end_date"
            id="end_date"
            placeholder={"End Date"}
            value={end_date}
            onChangeHandler={(e) => onChangeHandler(e)}
          />
        </div>
        <div className="col-md-4 mt-3">
          <Select
            name="request_type"
            id="request_type"
            placeholder={"Request Type"}
            value={request_type}
            onChangeHandler={(e) => onChangeHandler(e)}
            options={requestTypeList && requestTypeList}
          />
        </div>
        <div className="col-md-4 mt-3">
          <Select
            name="reply_status"
            id="reply_status"
            value={reply_status}
            onChangeHandler={(e) => onChangeHandler(e)}
            options={[
              { id: "", name: "Select Status" },
              { id: "0", name: "Open" },
              { id: "1", name: "Closed" },
              { id: "2", name: "Closed and follow-up required" },
              { id: "3", name: "Acknowledged" },
            ]}
          />
        </div>
        <div className="col-md-3 mt-3">
          <Button type="submit" variant="primary" onClick={searchHandler}>
            Search
          </Button>
          <Button type="submit" variant="secondary" className="ms-2" onClick={resetHandler}>
            Reset
          </Button>
        </div>
        <div className="row mt-3">
          <div className="col-md-4 mx-1">
            <MultiSelect
              name={`excel_headers`}
              options={headerArray.map((val) => ({
                id: val.id,
                name: val.name,
              }))}
              selectedValues={selectedHeaders}
              id={"excel_headers"}
              onChangeHandler={(e) => excelHeaderHandler(e)}
              displayValue="name"
              closeOnSelect={false}
              placeholder="Select Headers"
            />
          </div>
          <div className="col-md-2">
            <Button
              type="submit"
              variant="success"
              onClick={(e) => excelDownloadHandler(e, "download")}
            >
              {isDownloadLoader ? "downloading..." : "Download"}
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default QueryFilter;
